<label class="message-to" *ngIf="!showNameAndEmail && !excludeCcBccFields">
  To
  <mat-form-field appearance="outline" floatLabel="always">
    <input matInput [value]="recipientLabel" name="message_to" disabled="disabled" />
  </mat-form-field>
</label>

<fieldset class="reply-options" *ngIf="enableFromAlias || !disableReplyTo">
  <label class="from-alias" *ngIf="enableFromAlias">
    <span class="tooltip-wrapper">
      From Display Name
      <span
          class="help-icon"
          inlineSVG="/assets/icons/info-2.svg"
          matTooltip="The name recipients will see in their inbox. Please note, the 'from' email will be <no-reply@flowinc.com>"
          matTooltipClass="message-tooltip"
          matTooltipPosition="above"
        ></span>
    </span>
    <mat-form-field appearance="outline" floatLabel="always">
      <input
        matInput
        name="from"
        placeholder="Enter from display name"
        [(ngModel)]="fromAlias"
        (ngModelChange)="fromAliasChangeEvent($event)"
      />
    </mat-form-field>
  </label>

  <label class="message-reply-to" *ngIf="!disableReplyTo">
    <span class="tooltip-wrapper">
      Reply-to Address
      <span
        class="help-icon"
        inlineSVG="/assets/icons/info-2.svg"
        matTooltip="Allow recipients to reply directly to your inbox.  If left blank, this will default to <no-reply@flowinc.com>"
        matTooltipClass="message-tooltip"
        matTooltipPosition="above"
      ></span>
    </span>
    <mat-form-field appearance="outline" floatLabel="always">
      <input
        matInput
        (ngModelChange)="replyToChange.emit($event)"
        [pattern]="inputEmailPattern"
        [(ngModel)]="replyTo"
        placeholder="Enter reply-to address"
        name="message_reply_to"
      />
    </mat-form-field>
  </label>
</fieldset>

<label *ngIf="!noTemplate && messageTemplates$ | async as messageTempates">
  Message Template
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-select
      data-testid="template-select-input"
      [(ngModel)]="selectedMessageTemplate"
      name="type"
      placeholder="Select template"
      [disabled]="!messageTempates.length"
    >
      <mat-option *ngFor="let template of messageTempates" [value]="template" (click)="selectTemplate()">
        <div class="member-detail">
          <span class="template-title">{{ template.title }}</span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
</label>

<label class="full-name" *ngIf="showNameAndEmail">
  Full Name *
  <mat-form-field appearance="outline" floatLabel="always">
    <input
      data-testid="full-name-input"
      matInput
      (ngModelChange)="fullNameChangeEvent($event)"
      [(ngModel)]="fullName"
      [required]="true"
      name="full_name"
    />
  </mat-form-field>
</label>

<label class="email" *ngIf="showNameAndEmail">
  Email *
  <mat-form-field appearance="outline" floatLabel="always">
    <input
      data-testid="email-input"
      matInput
      (ngModelChange)="emailChangeEvent($event)"
      [pattern]="inputEmailPattern"
      [(ngModel)]="email"
      [required]="true"
      name="email"
    />
  </mat-form-field>
</label>

<label class="message-subject">
  Subject *
  <mat-form-field appearance="outline" floatLabel="always">
    <input
      (ngModelChange)="subjectChange.emit($event)"
      [(ngModel)]="subject"
      [required]="true"
      data-testid="subject-input"
      matInput
      name="message_subject"
      placeholder="Enter email subject"
    />
  </mat-form-field>
</label>

<div class="advanced-options" *ngIf="!excludeCcBccFields && !showAdvancedOptions && !disableAdvancedOptions">
  <span  data-testid="advanced-options-toggle" (click)="toggleAdvancedOptions()"> Add CC or BCC</span>
</div>

<label class="cc-recipients" *ngIf="showAdvancedOptions">
  <span class="tooltip-wrapper">
    CC
    <span
      class="help-icon"
      inlineSVG="/assets/icons/info-2.svg"
      matTooltip="Will receive copies of messages"
      matTooltipPosition="above"
    ></span>
  </span>
  <mat-form-field appearance="outline" floatLabel="always">
    <input
      matInput
      (ngModelChange)="ccRecipientsChange.emit($event)"
      [(ngModel)]="ccRecipients"
      [required]="false"
      placeholder="Enter comma separated list"
      name="carbon_copy_recipients"
    />
  </mat-form-field>
</label>

<ng-container *ngIf="showAdvancedOptions">
  <label class="bcc-recipients">
    <span class="tooltip-wrapper">
      BCC
      <span
        class="help-icon"
        inlineSVG="/assets/icons/info-2.svg"
        matTooltip="Will receive copies of messages without adding them to the reply list"
        matTooltipPosition="above"
      ></span>
    </span>
    <mat-form-field appearance="outline" floatLabel="always">
      <input
        matInput
        (ngModelChange)="bccRecipientsChange.emit($event)"
        [(ngModel)]="bccRecipients"
        [required]="false"
        placeholder="Enter comma separated list"
        name="blind_carbon_copy_recipients"
      />
    </mat-form-field>
  </label>
</ng-container>

<label class="message-message">
  Message<ng-container *ngIf="messageRequired"> *</ng-container>
  <mat-form-field appearance="outline" floatLabel="always" class="rich-editor">
    <input
      [(ngModel)]="froalaMessage"
      [hidden]="true"
      [required]="messageRequired"
      data-testid="message-input"
      matInput
      name="message_message"
    />
    <fl-froala-editor
      [(froalaModel)]="froalaMessage"
      [froalaEditor]="froalaOptions || froalaHelper.email"
    ></fl-froala-editor>
  </mat-form-field>
</label>

<div class="communication-preferences" *ngIf="enableCommunicationPreferences && (enableCommunicationPreferences$ | async)">
  <h2 class="modal-sub-heading">Communication Type</h2>

  <p>Select the type of communication this is, and only certain team members will receive a notification about this message.</p>
  <p>Alternatively, send this message to all team members.</p>
  <p>The primary contact for the investor will always receive all communications.</p>

  <fl-message-communication-types
    selectAllLabel="Include all team members"
    [communicationTypes]="communicationTypes"
    (communicationTypesChange)="communicationTypesChangeEvent($event)"
  ></fl-message-communication-types>
</div>
